import ReactDOMServer from 'react-dom/server';
import Translator from '../../../../components/helpers/Translator';

export const getRiskType = (number) => {
  let name = '';

  switch (number) {
    case 0:
      name = 'Estratégico';
      break;
    case 1:
      name = 'Operativo';
      break;
    case 2:
      name = 'Legal';
      break;
    case 3:
      name = 'Imagen';
      break;
    case 4:
      name = 'Financiero';
      break;
    case 5:
      name = 'Tecnológico';
      break;
    case 6:
      name = 'Corrupción';
      break;
    case 7:
      name = 'Fraude';
      break;
    default:
      name = '-';
      break;
  }

  return name;
};

export const getProbability = (number) => {
  let name = '';

  switch (number) {
    case 0:
      name = '1. Más de 30 años';
      break;
    case 1:
      name = '2. Cada 30 años';
      break;
    case 2:
      name = '3. Cada 10 años';
      break;
    case 3:
      name = '4. Cada 5 años';
      break;
    case 4:
      name = '5. Cada 3 años';
      break;
    case 5:
      name = '6. Anual o mayor';
      break;
    default:
      name = '-';
      break;
  }

  return name;
};

export const getImpactGroupType = (number) => {
  let name = '';

  switch (number) {
    case 0:
      name = 'Financiero';
      break;
    case 1:
      name = 'Legal';
      break;
    case 2:
      name = 'Imagen/Reputación';
      break;
    case 3:
      name = 'Estratégico';
      break;
    case 4:
      name = 'Medioambiental';
      break;
    case 5:
      name = 'Personas';
      break;
    case 6:
      name = 'RRHH';
      break;
    default:
      name = '-';
      break;
  }

  return name;
};

export const getInherentImpact = (number) => {
  let name = '';

  switch (number) {
    case 0:
      name = '1. Insignificante';
      break;
    case 1:
      name = '2. Menor';
      break;
    case 2:
      name = '3. Moderado';
      break;
    case 3:
      name = '4. Alto';
      break;
    case 4:
      name = '5. Muy alto';
      break;
    case 5:
      name = '6. Extremadamente alto';
      break;
    default:
      name = '-';
      break;
  }

  return name;
};

export const getRiskState = (number) => {
  let name = '';

  switch (number) {
    default:
    case 0:
      name = 'Pendiente completar datos riesgo';
      break;
    case 1:
      name = 'Pendiente introducir controles';
      break;
    case 2:
      name = 'Pendiente valoración riesgo';
      break;
    case 3:
      name = 'Pendiente aclaraciones área';
      break;
    case 4:
      name = 'Pendiente definir plan de acción';
      break;
    case 5:
      name = 'Completado';
      break;
  }

  return name;
};

export const getSeverity = (number) => {
  let name = '';

  switch (number) {
    case 0:
      name = '1. Baja';
      break;
    case 1:
      name = '2. Media';
      break;
    case 2:
      name = '3. Alta';
      break;
    case 3:
      name = '4. Muy alta';
      break;
    default:
      name = '-';
      break;
  }

  return name;
};

export const getPriority = (number) => {
  let name = '';

  switch (number) {
    case 0:
      name = 'Remediación prioritaria';
      break;
    case 1:
      name = 'Verificación';
      break;
    case 2:
      name = 'Vigilancia';
      break;
    case 3:
      name = 'Delegación';
      break;
    default:
      name = '-';
      break;
  }

  return name;
};

export const getRiskControlLevel = (number) => {
  let name = '';

  switch (number) {
    case 0:
      name = 'Sin control';
      break;
    case 1:
      name = 'Poco control ni conocimiento';
      break;
    case 2:
      name = 'Control insuficiente/inefectivo';
      break;
    case 3:
      name = 'Control no evaluado, mejorable';
      break;
    case 4:
      name = 'Control evaluado mejorable';
      break;
    case 5:
      name = 'Control probado y efectivo';
      break;
    default:
      name = '-';
      break;
  }

  return name;
};

export const getTotal = (number) => {
  let name = '';

  switch (number) {
    default:
    case 0:
      name = '1. Insignificante';
      break;
    case 1:
      name = '2. Menor';
      break;
    case 2:
      name = '3. Moderado';
      break;
    case 3:
      name = '4. Alto';
      break;
    case 4:
      name = '5. Muy alto';
      break;
    case 5:
      name = '6. Extremadamente alto';
      break;
  }

  return name;
};

export const getIf1 = (number) => {
  let name = '';

  switch (number) {
    default:
    case 0:
      name = '1. Insignificante (B2C <10k€ ; B2B<2,4k€)';
      break;
    case 1:
      name = '2. Menor (B2C ≥10k€ ; B2B≥2,4k€)';
      break;
    case 2:
      name = '3. Moderado (B2C ≥100k€ ; B2B≥24k€)';
      break;
    case 3:
      name = '4. Alto (B2C ≥500k€ ; B2B≥120k€)';
      break;
    case 4:
      name = '5. Muy alto (B2C ≥1M€ ; B2B≥240k€)';
      break;
    case 5:
      name = '6. Extremadamente alto (B2C ≥5M€ ; B2B≥1,2M€)';
      break;
  }

  return name;
};

export const getIf2 = (number) => {
  let name = '';

  switch (number) {
    default:
    case 0:
      name = '1. Insignificante (<500€)';
      break;
    case 1:
      name = '2. Menor (≥500€)';
      break;
    case 2:
      name = '3. Moderado (≥1k€)';
      break;
    case 3:
      name = '4. Alto (≥50k€)';
      break;
    case 4:
      name = '5. Muy alto (≥400k€)';
      break;
    case 5:
      name = '6. Extremadamente alto (≥1M€)';
      break;
  }

  return name;
};

export const getIl1 = (number) => {
  let name = '';

  switch (number) {
    default:
    case 0:
      name = '1. Insignificante (<10 Leves Consumo)';
      break;
    case 1:
      name = '2. Menor (<100 leves Consumo)';
      break;
    case 2:
      name = '3. Moderado (Grave Consumo)';
      break;
    case 3:
      name = '4. Alto (Leve RGPD/Sector)';
      break;
    case 4:
      name = '5. Muy alto (Muy grave Consumo/Grave RGPD/Grave Sector)';
      break;
    case 5:
      name = '6. Extremadamente alto (Muy grave RGPD/Muy grave sector)';
      break;
  }

  return name;
};

export const getIl2 = (number) => {
  let name = '';

  switch (number) {
    default:
    case 0:
      name = '1. Insignificante (<1k€ año)';
      break;
    case 1:
      name = '2. Menor (>1k€ año)';
      break;
    case 2:
      name = '3. Moderado (>10k€ año)';
      break;
    case 3:
      name = '4. Alto (>0.1M€ año)';
      break;
    case 4:
      name = '5. Muy alto (>0.5M€ año)';
      break;
    case 5:
      name = '6. Extremadamente alto (>1M€ año)';
      break;
  }

  return name;
};

export const getIl3 = (number) => {
  let name = '';

  switch (number) {
    default:
    case 0:
      name = '1. Insignificante';
      break;
    case 1:
      name = '2. Menor';
      break;
    case 2:
      name =
        '3. Moderado (Fraude o corrupción detectados en empresas colaboradoras detectados y gestionados a tiempo)';
      break;
    case 3:
      name =
        '4. Alto (Fraude o corrupción detectados en personal propio detectados y gestionados a tiempo)';
      break;
    case 4:
      name =
        '5. Muy alto (Fraude o corrupción en empresas colaboradoras no detectados y gestionados a tiempo)';
      break;
    case 5:
      name =
        '6. Extremadamente alto (Fraude o corrupción en personal propio no detectados y gestionados a tiempo)';
      break;
  }

  return name;
};

export const getIo1 = (number) => {
  let name = '';

  switch (number) {
    default:
    case 0:
      name = '1. Insignificante (B2C <2.700 ; B2B<36)';
      break;
    case 1:
      name = '2. Menor (B2C ≥2.700 ; B2B≥36)';
      break;
    case 2:
      name = '3. Moderado (B2C ≥27.000 ; B2B≥360)';
      break;
    case 3:
      name = '4. Alto (B2C ≥135.000 ; B2B≥1.800)';
      break;
    case 4:
      name = '5. Muy alto (B2C ≥270.000 ; B2B≥3.600)';
      break;
    case 5:
      name = '6. Extremadamente alto (B2C ≥1,35M ; B2B≥18.000)';
      break;
  }

  return name;
};

export const getIo2 = (number) => {
  let name = '';

  switch (number) {
    default:
    case 0:
      name = '1. Insignificante (retraso<1h)';
      break;
    case 1:
      name = '2. Menor (Interr<1h O retraso>1h)';
      break;
    case 2:
      name = '3. Moderado (Interr>1h O retraso>5h)';
      break;
    case 3:
      name = '4. Alto (Interr>3h O retraso>10h)';
      break;
    case 4:
      name = '5. Muy alto (Interr>12h O retraso>20h)';
      break;
    case 5:
      name = '6. Extremadamente alto (Interr>2días O retraso>40h)';
      break;
  }

  return name;
};

export const getIr1 = (number) => {
  let name = '';

  switch (number) {
    default:
    case 0:
      name = '1. Insignificante (<1.000 visualizaciones RRSS)';
      break;
    case 1:
      name = '2. Menor (>1.000 visualizaciones RRSS)';
      break;
    case 2:
      name = '3. Moderado (Medios Loc O >10.000 visualizaciones RRSS)';
      break;
    case 3:
      name = '4. Alto (Medios Aut O >50.000 visualizaciones RRSS)';
      break;
    case 4:
      name = '5. Muy alto (Medios Nac O >100.000 visualizaciones RRSS)';
      break;
    case 5:
      name =
        '6. Extremadamente alto (Medios Nac competencia/corrupción O >500.000 visualizaciones RRSS)';
      break;
  }

  return name;
};

export const getIr2 = (number) => {
  let name = '';

  switch (number) {
    default:
    case 0:
      name = '1. Insignificante (<10 Leves Consumo)';
      break;
    case 1:
      name = '2. Menor (<100 leves Consumo)';
      break;
    case 2:
      name = '3. Moderado (Grave Consumo)';
      break;
    case 3:
      name = '4. Alto (Leve RGPD/Sector)';
      break;
    case 4:
      name = '5. Muy alto (Muy grave Consumo/Grave RGPD/Grave Sector)';
      break;
    case 5:
      name = '6. Extremadamente alto (Muy grave RGPD/Muy grave sector)';
      break;
  }

  return name;
};

export const getIr3 = (number) => {
  let name = '';

  switch (number) {
    default:
    case 0:
      name = '1. Insignificante (B2C <800 ; B2B<10)';
      break;
    case 1:
      name = '2. Menor (B2C ≥800 ; B2B≥10)';
      break;
    case 2:
      name = '3. Moderado (B2C ≥4.000 ; B2B≥100)';
      break;
    case 3:
      name = '4. Alto (B2C ≥8.000 ; B2B≥500)';
      break;
    case 4:
      name = '5. Muy alto (B2C ≥16.000 ; B2B≥5.000)';
      break;
    case 5:
      name = '6. Extremadamente alto (B2C ≥32.000 ; B2B≥10.000)';
      break;
  }

  return name;
};

export const getIp1 = (number) => {
  let name = '';

  switch (number) {
    default:
    case 0:
      name = '1. Insignificante (Ningún accidente al año, sólo incidentes)';
      break;
    case 1:
      name = '2. Menor (1 Accidente leve al año)';
      break;
    case 2:
      name =
        '3. Moderado (Entre 1 y 10 accidentes al año con consecuencias leves)';
      break;
    case 3:
      name =
        '4. Alto (1 accidente al año con consecuencias graves o más de 10 leves)';
      break;
    case 4:
      name =
        '5. Muy alto (Entre 1 y 5 accidentes al año con consecuencias graves)';
      break;
    case 5:
      name =
        '6. Extremadamente alto (Accidente laboral con consecuencias de fallecimiento o incapacidad permanente o más de 5 accidentes al año con consecuencias graves)';
      break;
  }

  return name;
};

export const getIp2 = (number) => {
  let name = '';

  switch (number) {
    default:
    case 0:
      name = '1. Insignificante';
      break;
    case 1:
      name =
        '2. Menor (Baja de trabajadores indefinidos inferior al 1% de la plantilla)';
      break;
    case 2:
      name =
        '3. Moderado (Baja de trabajadores indefinidos entre el 1% y el 5% de la plantilla sin incidencia relevante en la prestación del servicio)';
      break;
    case 3:
      name =
        '4. Alto (Baja de trabajadores indefinidos entre el 1% y el 5% de la plantilla con incidencia relevante en la prestación del servicio)';
      break;
    case 4:
      name =
        '5. Muy alto (Baja de trabajadores superior al 5% de la plantilla)';
      break;
    case 5:
      name =
        '6. Extremadamente alto (Baja de trabajadores superior al 5% de la plantilla con incidencia relevante en la prestación del servicio)';
      break;
  }

  return name;
};
